import { Button, Space } from 'antd';
import styled from 'styled-components';

export const CustomHeader = styled.div`
  font-size: 11px;
  color: #748aa1;
  font-weight: 400;
  line-height: 16px;
  align-items: center;
  background: #fff;
`;

export const PopoverContainer = styled.div`
  padding: 16px;
  min-width: 46em;
  height: 35em;
  overflow-y: scroll;
`;

export const CenteredContainer = styled.div`
  display: grid;
  place-content: center;
  input {
    font-size: 12px;
    max-width: 100px;
    border-radius: 5px;
    padding: 4px;
    &:disabled {
      color: #00000099;
    }
  }
`;

export const LeftCenteredContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SetNameDiv = styled(Space)`
  display: flex;
  flex: 1;
  font-size: 12px;
  justify-content: space-between;
  border-radius: 4px;
  border: 1px solid #c0ddfa;
  background: #eff4f9;
  margin-bottom: 8px;
  padding: 4px 8px;
  align-items: center;
  .ant-space-item {
    width: auto;
  }
`;

export const ButtonLink = styled(Button)`
  border: 0;
  line-height: 1px;
  font-size: 12px;
  &:hover,
  &:focus {
    color: #1890ff !important;
  }
  svg {
    fill: #000;
    height: 12px;
    width: 12px;
  }
`;
